import React, { Component } from "react";
import Slider from "react-slick";
import ImageAlt from "./ImageAlt";

export default class Gallery extends Component {
	
	constructor(props) {
		super(props)
		this.onPlayIntersection = this.onPlayIntersection.bind(this);
		this.state = {
			index:0,
			prev:0,
			timer: 0,
			play:false,
			autoPlay:false,
			imagesToLoad:[0, 1, 2],
			maxIndex:0,
			inView:false
		}
	}
	
	componentDidMount() {
		
		const slides = this.props.slides;
						
		let maxIndex = slides.length - 1;
		
		let imagesToLoad = [0,1,2, maxIndex, (maxIndex - 1)];
				
		this.setState({
			maxIndex:maxIndex,
			imageToLoad:imagesToLoad
		})
	
		setTimeout(() => {
			const auto_change = this.props.auto_change;
			if (auto_change === true || auto_change === 'true') {
				this.setState({
					autoPlay: true
				});
				let playOptions = {
					root: null,
					rootMargin: "0px",
					threshold: 0
				};
				let playObserver = new IntersectionObserver(this.onPlayIntersection, playOptions);
				playObserver.observe(this.$gallery);
			}
		}, 1200);
		
		
	}
	
	onPlayIntersection(entries, observer) {
	    entries.map((entry) => {
		    if (this.$slider) {
				if (entry.intersectionRatio > 0 && this.state.play === false) {
					this.setState({
						play: true
					});
					this.$slider.slickPlay();
				} else if (entry.intersectionRatio === 0 && this.state.play === true) {
					this.setState({
						play: false
					});
					this.$slider.slickPause();
				}	
			}				
		});
	}
		
	render() {
		
		const has_caption = this.props.has_caption;
		const show_controls = this.props.show_controls;
		const auto_change = this.props.auto_change;
		const interval = this.props.interval;
		const slides = this.props.slides;
		const aspectratio = this.props.aspectratio;
		
		let controls = false;
		let controlsClass = 'c-gallery--no-controls';
		if (show_controls === true || show_controls === 'true') {
			controls = true;
			controlsClass = 'c-gallery--controls';
		}
		
		let captionClass = '';
		if (has_caption === true) {
			captionClass = 'c-gallery--has-caption';
		}
		
		let autoplaySpeed = parseInt(interval) * 1;
		
		const settings = {
			dots: 			controls,
			arrows: 		false,
			infinite: 		true,
			pauseOnHover: 	false,
			pauseOnFocus: 	false,
			speed: 			400,
			slidesToScroll: 1,
			accessibility:	true,
			centerMode: 	false,
			variableWidth: 	false,
			autoplay: 		this.state.autoPlay,
			autoplaySpeed: 	autoplaySpeed,
			beforeChange: 	(current, next) => {
				let nextIndex = next + 2;
				let prevIndex = next - 2;
				if (prevIndex === -1) {
					prevIndex = this.state.maxIndex;
				} else if (prevIndex === -2) {
					prevIndex = this.state.maxIndex - 1;
				}
				let imagesToLoad = this.state.imagesToLoad;
				if (!this.state.imagesToLoad.includes(nextIndex)) {
					imagesToLoad.push(nextIndex);
				}
				if (!this.state.imagesToLoad.includes(prevIndex)) {
					imagesToLoad.push(prevIndex);
				}
				this.setState({
					index: next,
					prev: current,
					imagesToLoad: imagesToLoad
				})
			}
		};
		
		let slidesEl = [];
		let captions = [];
		for (let j=0;j<slides.length;j++) {
			let doPlay = false;
			if (j === this.state.index || j === this.state.prev) {
				doPlay = true;
			}
			slidesEl.push(
				<div className={'c-gallery__slide c-gallery__slide--' + slides[j].fitting}>
					{this.state.imagesToLoad.includes(j) &&
						<>
							<ImageAlt src={slides[j].src} srcset={slides[j].srcset} />
							{slides[j].caption &&
								<p className="c-gallery__slide__caption" dangerouslySetInnerHTML={{__html: slides[j].caption}}></p>
							}
						</>
					}
				</div>
			)
		}
		
		return (
			
			<>
					
				<div ref={(gallery) => { this.$gallery = gallery; }}>
										
					<div className={'c-gallery ' + controlsClass + ' ' + captionClass} style={{paddingTop: aspectratio + '%'}}>
						
						<Slider ref={(slider) => { this.$slider = slider; }} {...settings}>
							{slidesEl}
						</Slider>
	
					
					</div>
																	
				</div>					
			
			</>
			
			
		)

	}
}
